Vue.asyncComponent('cms-dashboard-seo-unique-title-tags', {
    props: {
        title: {
            type: String,
            default: '',
        },
        statusValue: {
            type: String,
            default: '',
        },
        statusDescription: {
            type: String,
            default: '',
        },
        duplicateGroups: {
            type: Array,
            default: () => [],
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-seo-unique-title-tags.html');
